import { ExternalLiquidityStatsAction } from './actions'
import { ExternalLiquidityStats } from './types'

export interface State {
  externalLiquidityStats?: ExternalLiquidityStats[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  externalLiquidityStats: undefined,
  pending: false,
  error: false
}

export default (
  state = initialState,
  action: ExternalLiquidityStatsAction
): State => {
  switch (action.type) {
    case 'externalLiquidityStats.fetchData':
      return {
        ...state,
        externalLiquidityStats: undefined,
        pending: true,
        error: false
      }
    case 'externalLiquidityStats.fetchFail':
      return {
        ...state,
        externalLiquidityStats: undefined,
        pending: false,
        error: true
      }

    case 'externalLiquidityStats.addData':
      return {
        ...state,
        externalLiquidityStats: action.payload,
        pending: false,
        error: false
      }

    default:
      return state
  }
}
